import { Observable, of } from 'rxjs';

import { Credentials, LoginContext } from '../authentication/authentication.service';

export class MockAuthenticationService {

  credentials: Credentials | null = {
    username: 'INT',
    token: 'admin',
    type: null,
  };

  login(context: LoginContext): Observable<Credentials> {
    return of({
      username: context.username,
      token: 'admin',
      type: 'AGENT',
    });
  }

  logout(): Observable<boolean> {
    this.credentials = null;
    return of(true);
  }

  isAuthenticated(): boolean {
    return !!this.credentials;
  }

}
